import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'
import { createBrowserHistory } from 'history'
import { combineReducers } from 'redux'
import { createReduxHistoryContext } from 'redux-first-history'

import appSlice from './features/app/appSlice'
import authReducer from './features/auth/authSlice'
import chatReducer from './features/chat/chatSlice'
import notificationReducer from './features/notifications/notificationsSlice'
import { baseApi } from './services/baseApi'

// Setup redux-first-history
const { createReduxHistory, routerMiddleware, routerReducer } =
    createReduxHistoryContext({ history: createBrowserHistory() })
export const store = configureStore({
    devTools: process.env.NODE_ENV === 'development',
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat([baseApi.middleware, routerMiddleware]),
    reducer: combineReducers({
        router: routerReducer,
        auth: authReducer,
        chat: chatReducer,
        app: appSlice,
        notifications: notificationReducer,
        [baseApi.reducerPath]: baseApi.reducer,
    }),
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch

setupListeners(store.dispatch)
export const history = createReduxHistory(store)
